export class SubscriptionPlanName {
  private readonly _brand = SubscriptionPlanName.name;
  constructor(public readonly value: string) {}
}
